/**
 * Team Management translations
 * Team management page UI text
 */

import { LANGUAGES } from '../config';

export const teamManagementTranslations = {
  [LANGUAGES.EN]: {
    title: 'Team Management',
    description: 'View and manage your team members\' CV analyses and job skills',
    featureComingSoon: 'Feature coming soon',
    yourTeamMembers: 'Your Team Members',
    noTeamMembers: 'You don\'t have any team members assigned yet.',
    allEmployees: 'All Employees',
    noEmployees: 'No employees found in the system.',
    role: 'Role: ',
    department: 'Department: ',
    cvAnalysis: 'CV Analysis',
    jobSkills: 'Job Skills',
    trainingRecommendations: 'Training Recommendations',
    backToTeamList: 'Back to Team List',
    cvAnalysisFor: 'CV Analysis for {name}',
    jobSkillsFor: 'Job Skills for {name}',
    trainingRecommendationsFor: 'Training Recommendations for {name}',
    editable: '(Editable)',
    teamOverview: 'Team Overview',
    performance: 'Performance',
    developmentPlans: 'Development Plans',
    items: 'Items',
    item: 'Item',
    itemName: 'Item Name',
    itemType: 'Item Type',
    itemDescription: 'Item Description',
    itemStatus: 'Item Status',
    itemDate: 'Item Date',
    itemOwner: 'Item Owner',
    itemPriority: 'Item Priority',
    itemCategory: 'Item Category',
    itemTags: 'Item Tags',
    itemActions: 'Item Actions',
    itemDetails: 'Item Details',
    itemEdit: 'Edit Item',
    itemDelete: 'Delete Item',
    itemView: 'View Item',
    itemAdd: 'Add Item',
    itemSearch: 'Search Items',
    itemFilter: 'Filter Items',
    itemSort: 'Sort Items',
    itemExport: 'Export Items',
    itemImport: 'Import Items',
    for: 'for',
    searchByName: 'Search by name',
    searchPlaceholder: 'Type name to search...',
    filterByDepartment: 'Filter by department',
    noMatchingUsers: 'No users match the current filters',
    usersShown: 'users shown',
    skillsGapReport: 'Skills Gap Report',
    teamSkillsGapReport: 'Team Skills Gap Report',
    companySkillsGapReport: 'Company Skills Gap Report'
  },
  [LANGUAGES.FR]: {
    title: 'Gestion d\'équipe',
    description: 'Voir et gérer les analyses de CV et les compétences professionnelles de vos membres d\'équipe',
    featureComingSoon: 'Fonctionnalité à venir',
    yourTeamMembers: 'Membres de votre équipe',
    noTeamMembers: 'Vous n\'avez pas encore de membres d\'équipe assignés.',
    allEmployees: 'Tous les employés',
    noEmployees: 'Aucun employé trouvé dans le système.',
    role: 'Rôle : ',
    department: 'Département : ',
    cvAnalysis: 'Analyse de CV',
    jobSkills: 'Compétences professionnelles',
    trainingRecommendations: 'Recommandations de formation',
    backToTeamList: 'Retour à la liste d\'équipe',
    cvAnalysisFor: 'Analyse de CV pour {name}',
    jobSkillsFor: 'Compétences professionnelles pour {name}',
    trainingRecommendationsFor: 'Recommandations de formation pour {name}',
    editable: '(Modifiable)',
    teamOverview: 'Vue d\'ensemble de l\'équipe',
    performance: 'Performance',
    developmentPlans: 'Plans de développement',
    items: 'Éléments',
    item: 'Élément',
    itemName: 'Nom de l\'élément',
    itemType: 'Type d\'élément',
    itemDescription: 'Description de l\'élément',
    itemStatus: 'Statut de l\'élément',
    itemDate: 'Date de l\'élément',
    itemOwner: 'Propriétaire de l\'élément',
    itemPriority: 'Priorité de l\'élément',
    itemCategory: 'Catégorie de l\'élément',
    itemTags: 'Tags de l\'élément',
    itemActions: 'Actions de l\'élément',
    itemDetails: 'Détails de l\'élément',
    itemEdit: 'Modifier l\'élément',
    itemDelete: 'Supprimer l\'élément',
    itemView: 'Voir l\'élément',
    itemAdd: 'Ajouter un élément',
    itemSearch: 'Rechercher des éléments',
    itemFilter: 'Filtrer les éléments',
    itemSort: 'Trier les éléments',
    itemExport: 'Exporter les éléments',
    itemImport: 'Importer les éléments',
    for: 'pour',
    searchByName: 'Rechercher par nom',
    searchPlaceholder: 'Tapez le nom à rechercher...',
    filterByDepartment: 'Filtrer par département',
    noMatchingUsers: 'Aucun utilisateur ne correspond aux filtres actuels',
    usersShown: 'utilisateurs affichés',
    skillsGapReport: 'Rapport des lacunes de compétences',
    teamSkillsGapReport: 'Rapport des lacunes de compétences de l\'équipe',
    companySkillsGapReport: 'Rapport des lacunes de compétences de l\'entreprise'
  }
};
